import { z } from "zod";
import { notificationSchema } from "../utils";
import { externalOnlySchema, internalOnlySchema } from "./approvedByMDGarbageDisposalSchema";

export const notesOnlySchema = () =>
  z.object({
    notes: z.string().optional(),
  });

export const incidentsOnlySchema = () =>
  z.object({
    incidents: z.string().max(2500).optional(),
  });

export const approvedByMDSludgeDisposalSchema = () =>
  internalOnlySchema.merge(externalOnlySchema).merge(notificationSchema);

export type ApprovedByMDSludgeDisposalSchema = z.infer<
  ReturnType<typeof approvedByMDSludgeDisposalSchema>
>;
